export default __webpack_public_path__ + "static/media/icon-fakturiert.724abbb8.svg";